(function () {
    const $ = window.jQuery || window.$ || require('jquery');

    const videojsMod = require('video.js');
    const videojs = videojsMod.default || videojsMod;

    const moment = require('moment-timezone');
    require('videojs-errors');
    require('videojs-ga');

    const { v4: uuidv4 } = require('uuid');

    // img via loader: kan default of plain string zijn
    const urlMod = require('../assets/ec-bg-169.jpg');
    const url = urlMod.default || urlMod;

    require('../styles/main.css');
    require('@videojs/themes/dist/sea/index.css');

    const translationsMod = require('./translations');
    const translations = translationsMod.default || translationsMod;

    const languagesMod = require('./languages');
    const languages = languagesMod.default || languagesMod;

    class smvplayer {
        constructor() {

            moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone);

            //TEMP VARIABLES 
            this.application = "";
            this.audioLang = "or";
            this.audioLangs = [];
            this.quality = "";
            this.qualityLevels = [];
            this.autostart = false;
            this.backgroundUrl = "";
            this.buffering = false;
            this.callbacks = {};
            this.clientIp = "";
            this.engine = "";
            this.lastMessage = false;
            this.lastPlayedPos = 1;
            this.pauseAfterReload = false;
            this.activePlayers = [];
            this.m = [
                "android_hlsjs",
                "android_html5",
                "android_rtsp",
                "ios",
                "osx_unicast_flash",
                "osx_unicast_html",
                "osx_unicast_rtmp",
                "windows_unicast_flash",
                "windows_unicast_html",
                "windows_unicast_rtmp",
                "windows_multicast",
                "windowsphone",
                "linux_unicast_flash",
                "linux_unicast_html",
                "linux_unicast_rtmp",
                "linux_multicast",
                "playstation",
                "xbox",
                "other"
            ];

            this.mode = "";
            this.multicast = false;
            this.ports = {};
            this.sInitMediaUrl = false;
            this.server = "";
            this.status = [];
            this.skin = "";
            this.streamType = null;
            this.skins = [
                'default.css', // Default (Light Blue)
                'manly.css', // The Manly Skin! (Pink!)
                'dbv.css', // DBVideo Skin (Red)
                'nnhq.css', // NNHQ (Dark Blue)
                'standard.css', // Standard Skin (Black 'n' White)
                'cms.css', // CMS styled skin.
                'ec.css', // European Commission Skin (Blue-ish)
                'greens.css', // GreensEFA Player Skin (Greenish)
                'antwerp.css', // Stad Antwerpuh (Zet die ploat af)
                'ep.css', // EP Player3 Skin.
                'demo.css',
                'epp.css',
                'guengl.css',
                'hmsk.css',
                'smv.css'
            ];

            this.networkError = false;
            this.showDisclaimer = false;
            this.timeline = {
                currentItem: 0,
                playlist: [{
                    source: {}
                }],
                finished: false
            };
            this.timelineSync = false;
            this.uiLabels = {};
            this.userMediaUrl = false;
            this.unicastFallback = false;
            this.unicastfallbacktimeout = 0;
            this.registeredCallbacks = {};
            this.playlist = {}
            this.progressInterval = null
            this.playPromises = []
            this.fullyPlayed = false
            this.seekSteps = 5
            this.translations = new translations()
            this.languages = new languages()
            //END TEMP VARS



            //secure token emits
            this.tokenRefreshHandler = null;
            this.refreshingTokens = false;
            this.lastTokenRefreshAt = 0;

        }

        //event emitters 

        on(evt, cb) {
            if (!this._events[evt]) this._events[evt] = [];
            this._events[evt].push(cb);
        }

        off(evt, cb) {
            if (!this._events[evt]) return;
            this._events[evt] = this._events[evt].filter(fn => fn !== cb);
        }

        emit(evt, payload) {
            (this._events[evt] || []).forEach(fn => {
                try { fn(payload); } catch (e) { }
            });
        }

        init(playerIds, channelIds, playlist = [], reference, playersInitialised, options = null) {
            this.ids = playerIds;
            this.playlist = playlist;
            this.reference = reference;
            this.ports = playlist.ports;
            this.server = playlist.server;
            this.clientIp = playlist.clientIp;
            this.posterIMG = url;
            this.playerIds = playerIds;
            this.status = null;
            this.enableSync = true
            this.mainPlayer = this.ids[0]
            this.retries = 0;
            this.retries_limit = 5;
            this.player = null;
            this.isPlaying = false;
            this.liveTranscriptions = []
            this.selectedSub = null
            this.subs = null

            this.debug = true;

            this.smil = null;
            if (this.playlist.playlists) {
                this.smil = this.playlist.playlists[0].playlist[0].source.smil
            }


            console.log('-------- CREATING instances --------');

            this.destroy();

            this.createInstance(this.ids);

            this.ids.forEach(id => {
                this.player = videojs(id, {
                    controlBar: {
                        'pictureInPictureToggle': false
                    },
                    liveui: true,
                    textTrackSettings: false,
                    liveTracker: true
                });
            });

            if (options) {
                this.planned = options.planned
                this.private = options.private
                this.recording = options.recording
                this.status = options.status

                if (this.status === 'invalid') {
                    this.status = 'done'
                }

                this.public = options.public
                this.locked = options.locked
                this.secure = options.secure
                this.published = options.published
                this.multicast = options.multicast
            }

            let parent = this

            if (this.public === "0" && this.status !== 'live') {
                this.status = 'internal'
            }

            if (this.status !== 'internal' && this.secure === "1" && this.status !== 'live') {
                this.status = 'secure'
            }

            //Each channel has its own source, here the proper Media URL will be created and attached to the proper videojs instance.
            console.log('-------- generating media url and attaching to player instances --------');
            this.install403Handler();
            for (var i = 0; i < this.playerIds.length; i++) {
                if ((this.status !== 'planned' && this.status !== 'done' && this.status !== 'invalid' && this.status !== 'vod-unavailable' && this.status !== 'live-unavailable' && this.status !== 'internal') || (this.status === 'internal' && this.playlist.valid)) {
                    if (this.multicast && (typeof this.multicast === 'object' && this.multicast !== null)) {
                        parent.setStatusMessages('Please watch this session using <a  id="webcastlink" href="ecwebcast://' + this.reference + '">EC Webcast Player</a>', 'ecwebcast')
                    } else {
                        if (this.playlist) {


                            videojs.getPlayer(this.playerIds[i]).src({
                                type: 'application/x-mpegURL',
                                src: this.mediaUrl(i, 0)
                            });

                        } else {
                            videojs.getPlayer(this.playerIds[i]).src({
                                type: 'application/x-mpegURL',
                                src: null
                            });
                            parent.setStatusMessages(this.translations.getTranslation(this.status.toLowerCase()), 'no-close')
                        }
                    }
                } else {
                    parent.setStatusMessages(this.translations.getTranslation(this.status.toLowerCase()), 'no-close')
                    //videojs.getPlayer(this.ids[i]).reset()
                }

                //Add a poster, will be shown when page is loaded or audio only
                //TODO: Make url dynamic so that each customer can have its own poster
                videojs.getPlayer(this.ids[i]).poster(this.posterIMG);

                videojs(this.ids[i]).ready(function () {
                    const player = this;

                    // per smvplayer retries per player id
                    parent._retriesById ??= {};
                    parent._retriesById[player.id()] ??= 0;

                    const getSrc = () => {
                        try {
                            const cur = player.currentSource?.();
                            return cur?.src || player.src?.() || '(no src)';
                        } catch (e) {
                            return '(src read failed)';
                        }
                    };

                    const logCtx = (tag, extra = {}) => {
                        parent._debugLog(tag, {
                            playerId: player.id(),
                            retries: parent._retriesById[player.id()],
                            src: getSrc(),
                            isPlaying: !player.paused?.(),
                            networkError: parent.networkError,
                            ...extra
                        });
                    };

                    // ====== Retry playlist ======
                    player.tech(true).on('retryplaylist', () => {
                        parent._retriesById[player.id()]++;

                        logCtx('[vhs] retryplaylist', {
                            retries_limit: parent.retries_limit
                        });

                        if (parent._retriesById[player.id()] >= parent.retries_limit) {
                            // guard zodat je niet blijft spammen
                            parent._retriesById[player.id()]++;

                            logCtx('[vhs] retries_limit reached -> OFFLINE', {
                                action: 'setStatusMessages + stop + setCustomSource(null)'
                            });

                            parent.networkError = true;
                            parent.setStatusMessages(parent.translations.getTranslation('done'), 'no-close');
                            parent.setCustomSource(null);
                            parent.stop();
                        }
                    });

                    // ====== Recovery handler ======
                    const markRecovered = (reason) => {
                        // als we niet "offline" zijn, log enkel af en toe
                        if (!parent.networkError && !parent._debugThrottle(`recovered:${player.id()}`, 2000)) return;

                        logCtx('[net] RECOVERED', { reason });

                        parent._retriesById[player.id()] = 0;
                        parent.networkError = false;
                        parent.clearStatusMessages();
                    };

                    // recovery signals
                    player.on('playing', () => markRecovered('playing'));
                    player.on('canplay', () => markRecovered('canplay'));
                    player.on('loadedmetadata', () => markRecovered('loadedmetadata'));
                    player.on('loadeddata', () => markRecovered('loadeddata')); // extra

                    // ====== Buffer / stall signals ======
                    player.on('waiting', () => {
                        // waiting kan veel gebeuren -> throttle
                        if (parent._debugThrottle(`waiting:${player.id()}`, 1500)) {
                            logCtx('[net] waiting');
                        }
                    });

                    player.on('stalled', () => {
                        if (parent._debugThrottle(`stalled:${player.id()}`, 1500)) {
                            logCtx('[net] stalled');
                        }
                    });

                    // ====== Errors ======
                    player.on('error', function (e) {
                        e.stopImmediatePropagation();

                        const err = player.error?.() || {};
                        const tech = player.tech?.(true);

                        const vhs = player.tech?.(true)?.vhs || player.tech?.(true)?.Vhs || null;

                        parent._debugLog('[vjs] ERROR', {
                            playerId: player.id(),
                            err,
                            code: err.code,
                            message: err.message,
                            src: (() => {
                                try { return player.currentSource?.()?.src || player.src?.(); } catch { return '(no src)'; }
                            })(),
                            readyState: player.readyState?.(),
                            networkState: player.networkState?.(),
                            currentTime: player.currentTime?.(),
                            paused: player.paused?.(),
                            // soms interessant:
                            buffered: (() => {
                                try {
                                    const b = player.buffered?.();
                                    if (!b || b.length === 0) return [];
                                    return Array.from({ length: b.length }).map((_, i) => [b.start(i), b.end(i)]);
                                } catch { return '(buffered read failed)'; }
                            })(),
                            vhs: vhs ? {
                                // niet altijd aanwezig in elke build
                                bandwidth: vhs.bandwidth,
                                throughput: vhs.throughput,
                                mediaRequests: vhs.stats?.mediaRequests,
                                playlistRequests: vhs.stats?.playlistRequests
                            } : null
                        });

                        // decode recovery
                        if (err && err.code === 3) {
                            parent._handleDecodeError(player, err);
                        }
                    });


                    // ====== Optional: timeupdate/progress (throttled) ======
                    player.on('timeupdate', () => {
                        if (!parent._debugThrottle(`time:${player.id()}`, 5000)) return;
                        logCtx('[vjs] timeupdate', { t: player.currentTime?.() });
                    });

                    player.on('progress', () => {
                        if (!parent._debugThrottle(`progress:${player.id()}`, 5000)) return;
                        logCtx('[vjs] progress');
                    });

                    // ====== Startup log ======
                    logCtx('[vjs] ready');
                });





                /*
                videojs(this.playerIds[i]).on('waiting', (i) => {
                    this.stop()
                    setTimeout(() => {
                        this.play()
                    }, 1000)
                })
                */

                //videojs('player1').ga();
            }

            this.scheduleTokenRefreshFromPlaylist();


            if (this.ids.length > 1) {
                this.addCustomClickEvents()
            }


            this.player.on('waiting', () => {
                this.isPlaying = false
            })

            this.player.on('playing', () => {
                this.isPlaying = true
            })

            this.player.on('play', () => {

                if (this.status === 'live') {
                    $('.vjs-seek-to-live-control').trigger('click')
                }
            })

            if (this.playlist && this.status !== 'live' && this.status !== 'planned') {
                this.addCustomRealTimeDisplay()
                this.createSeekBar(playlist)

                this.timeline = {
                    currentItem: 0,
                    playlist: playlist.playlists[0].playlist,
                    finished: false,
                    secondsPlayed: 0
                };

            }

            if (this.playlist && this.status !== 'planned') {
                this.addLanguageControl();
                this.addQualityControl();

                this.addSeekStepControl()
            }


            playersInitialised();
        }

        _handleDecodeError(player, err) {
            this._decodeRetriesById ??= {};
            const id = player.id();
            this._decodeRetriesById[id] ??= 0;
            this._decodeRetriesById[id]++;

            const attempt = this._decodeRetriesById[id];

            this._debugLog('[decode] MEDIA_ERR_DECODE -> attempt recover', {
                playerId: id,
                attempt,
                err
            });

            // na X pogingen: toon pas message
            if (attempt === 1) {
                this.setStatusMessages('Stream hiccup detected… attempting recovery.', 'no-close');
            }

            // throttle zodat je niet in een tight loop komt
            if (this.__decodeRecovering) return;
            this.__decodeRecovering = true;

            const isLive = this.status === 'live';

            // bewaar positie indien VOD
            const pos = (!isLive ? this.getCurrentPosition() : null);
            const curItem = this.timeline?.currentItem ?? 0;

            // “hard” reset van MSE/tech helpt vaak bij decode issues
            try {
                player.pause();
                player.reset(); // reset tech + source
            } catch { }

            // zet dezelfde source opnieuw
            const srcUrl = this.mediaUrl(0, isLive ? 0 : curItem);

            this._debugLog('[decode] reloading src', { playerId: id, srcUrl });

            player.src({ type: 'application/x-mpegURL', src: srcUrl });

            player.ready(() => {
                try {
                    if (this.subs) this.addSubs(this.subs);

                    if (isLive) {
                        $('.vjs-seek-to-live-control').trigger('click');
                    } else if (pos) {
                        player.currentTime(pos.timePassed);
                    }

                    player.play();
                    this.clearStatusMessages(); // bij succes zal playing ook nog eens clearen
                } catch (e) {
                    this._debugLog('[decode] recovery play failed', { e: String(e) });
                } finally {
                    this.__decodeRecovering = false;
                }
            });

            // na bv. 3 decode failures: geef echt op
            if (attempt >= 3) {
                this._debugLog('[decode] too many decode failures -> OFFLINE', { playerId: id, attempt });
                this.setStatusMessages('Stream unavailable (decode errors).', 'no-close');
                this.stop();
            }
        }


        _setOffline(msg) {
            this.networkError = true;
            this.setStatusMessages(msg, 'no-close');
        }

        _debugLog(...args) {
            // zet op false om alles uit te zetten
            if (this.debug === false) return;

            const ts = new Date().toISOString();
            console.log(`[smvplayer ${ts}]`, ...args);
        }

        // simpele throttle per key
        _debugThrottle(key, ms) {
            this.__dbgLast ??= {};
            const now = Date.now();
            if (this.__dbgLast[key] && (now - this.__dbgLast[key]) < ms) return false;
            this.__dbgLast[key] = now;
            return true;
        }



        changePipPosition(position) {
            var $smallPlayer = $('.vjs-second-player')
            var positions = ['top-left', 'top-right', 'bottom-left', 'bottom-right']

            positions = positions.filter(pos => {
                return position !== pos
            })

            positions.forEach(pos => {
                $smallPlayer.removeClass(pos)
            })

            switch (position) {
                case 'top-left':
                    $smallPlayer.addClass('top-left')
                    break;
                case 'top-right':
                    $smallPlayer.addClass('top-right')
                    break;
                case 'bottom-left':
                    $smallPlayer.addClass('bottom-left')
                    break;
                case 'bottom-right':
                    $smallPlayer.addClass('bottom-right')
                    break;
            }
        }

        swapPlayers() {
            if (this.ids.length > 1) {
                $('#' + this.ids[1]).show()
                this.mainPlayer = this.mainPlayer == this.ids[0] ? this.ids[1] : this.ids[0]

                let $parent = $('#' + this.ids[0])
                let $child = $('#' + this.ids[1])

                let $parentPlayer = $parent.find('video')
                let $childPlayer = $child.find('video')

                $child.find('video').remove()
                $child.prepend($parentPlayer)

                $parent.find('video').remove()
                $parent.prepend($childPlayer)
            }
        }

        hidePresentation() {
            if (this.mainPlayer === this.ids[1]) {
                this.swapPlayers()
            }

            $('#' + this.ids[1]).hide()
        }

        hideVideo() {
            if (this.mainPlayer === this.ids[0]) {
                this.swapPlayers()
            }

            $('#' + this.ids[1]).hide()
        }

        createSeekBar(playlist) {
            moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

            let $seekbar = '<div id="seekbar"><div id="progress"><div id="seek"></div><div id="seekpoint"></div></div>'

            for (let i = 0; i < playlist.playlists.length; i++) {
                let item = playlist.playlists[i]

                $seekbar += '<div id="playlist_' + (String(i + 1)) + '" class="playlist" data-item="' + i + '">'
                item.playlist = item.playlist.sort((p1, p2) => (moment(p1.startTime) > moment(p2.startTime)) ? 1 : (moment(p1.startTime) < moment(p2.startTime)) ? -1 : 0);
                for (let ii = 0; ii < item.playlist.length; ii++) {
                    let playlistItem = item.playlist[ii]
                    let firstItem = item.playlist[0]
                    let lastItem = item.playlist[item.playlist.length - 1]

                    let totalDuration = moment(lastItem.stopUTC * 1000).diff(firstItem.startUTC * 1000);
                    let itemDuration = moment(playlistItem.stopUTC * 1000).diff(playlistItem.startUTC * 1000);

                    let itemDurationPercentage = ((itemDuration / totalDuration) * 100).toFixed(3)

                    $seekbar += '<div id="playlist__item__' + (String(ii + 1)) + '" class="playlist__item" style="width:' + itemDurationPercentage + '%;" data-item="' + (String(ii)) + '"></div>'

                    if (item.playlist[ii + 1]) {
                        let nextItem = item.playlist[ii + 1]

                        let pauseDuration = moment(nextItem.startUTC * 1000).diff(playlistItem.stopUTC * 1000);

                        let pauseDurationPercentage = ((pauseDuration / totalDuration) * 100).toFixed(3)

                        $seekbar += '<div class="playlist__pause" style="width:' + pauseDurationPercentage + '%;" data-item="pause"></div>'
                    }
                }

                $seekbar += '</div>'
            }
            $seekbar += '</div>'

            $('.vjs-control-bar').append($seekbar)

            $('#seekbar').on('click', this.seekbarClickHandler.bind(this))

            videojs.getPlayer(this.playerIds[0]).on('play', (e) => {
                if (!this.progressInterval) {
                    this.progressInterval = setInterval(() =>
                        this.updateProgressBar(), 500
                    )
                }
            })

            videojs.getPlayer(this.playerIds[0]).on('pause', (e) => {
                clearInterval(this.progressInterval)
                this.progressInterval = null
            })

            videojs.getPlayer(this.playerIds[0]).on('ended', () => {
                this.playlistItemDone()
            });
        }

        addKeyboardEvents() {

        }

        updateProgressBar() {
            if (this.isPlaying) {
                let currentWidth = $('#progress').width()
                let totalWidth = $('#seekbar').width() + 1

                if (this.fullyPlayed) {
                    this.fullyPlayed = false
                    currentWidth = 0
                    videojs.getPlayer(this.playerIds[0]).src({
                        type: 'application/x-mpegURL',
                        src: this.mediaUrl(0, this.timeline.currentItem)
                    })
                }


                let startTime = this.playlist.playlists[0].playlist[0].startUTC

                if (typeof startTime === 'string') startTime = parseInt(startTime, 10);

                let stopTime = this.playlist.playlists[0].playlist[this.playlist.playlists[0].playlist.length - 1].stopUTC

                if (typeof stopTime === 'string') stopTime = parseInt(stopTime, 10);

                let StartTimeCurrentPlaylist = this.playlist.playlists[0].playlist[this.timeline.currentItem].startUTC

                if (typeof StartTimeCurrentPlaylist === 'string') StartTimeCurrentPlaylist = parseInt(StartTimeCurrentPlaylist, 10);
                let secondsPlayedThisFile = this.player.currentTime()

                let secondsPlayed = moment(StartTimeCurrentPlaylist).diff(startTime) + secondsPlayedThisFile

                this.timeline.secondsPlayed = secondsPlayed

                let totalSeconds = moment(stopTime).diff(startTime)

                let newWidthPercentage = secondsPlayed / totalSeconds * 100

                $('#progress').width(newWidthPercentage + '%')
            }
        }

        playlistItemDone() {
            if (this.timeline.currentItem < this.playlist.playlists[0].playlist.length - 1) {
                let playlistItem = this.playlist.playlists[0].playlist[this.timeline.currentItem + 1]

                this.timeline = {
                    currentItem: this.timeline.currentItem + 1,
                    playlist: [playlistItem],
                    finished: false
                };


                let mouseX = $('#playlist__item__' + (this.timeline.currentItem))[0].offsetLeft

                let seekBarWidth = $('#seekbar').width()
                $('#progress').width((mouseX / seekBarWidth) * 100 + '%')

                this.player.src({
                    type: 'application/x-mpegURL',
                    src: this.mediaUrl(0, this.timeline.currentItem)
                })


                this.player.ready(() => {
                    let startTimeUTC = playlistItem.startUTC
                    this.seek(startTimeUTC)
                    this.play()
                    this.addSubs(this.subs)
                });

            } else {
                this.fullyPlayed = true
                this.timeline = {
                    currentItem: 0,
                    playlist: this.playlist.playlists[0].playlist,
                    finished: false
                };
            }
        }

        seekbarClickHandler(e) {
            let clickedPlaylistItemIndex = $(e.target).data('item')

            let clickedPlaylistChannelIndex = $(e.target).parent().data('item')
            let sameItem = true

            let mouseX = e.pageX - e.currentTarget.getBoundingClientRect().x

            if (clickedPlaylistItemIndex === 'pause') {
                mouseX = $(e.target).next()[0].offsetLeft
            }

            let seekBarWidth = $(e.currentTarget).width()
            $('#progress').width((mouseX / seekBarWidth) * 100 + '%')

            let clickedPos = 0
            let clickedpPlaylistWidth = $(e.target).width()

            if (e.offsetX === undefined) {
                clickedPos = e.pageX - progress.offset().left
            } else {
                clickedPos = e.offsetX;
            }

            if (clickedPlaylistItemIndex === 'pause') {
                clickedPlaylistItemIndex = $(e.target).next().data('item')

                if (!clickedPlaylistItemIndex) {
                    clickedPlaylistItemIndex = this.playlist.playlists[0].playlist.length - 1
                }

                clickedPos = 0
            }

            let playlistItem = this.playlist.playlists[clickedPlaylistChannelIndex].playlist[clickedPlaylistItemIndex]

            if (clickedPlaylistItemIndex !== this.timeline.currentItem) {
                sameItem = false
                this.timeline = {
                    currentItem: clickedPlaylistItemIndex,
                    playlist: [playlistItem],
                    finished: false
                };
            }

            let clickedPosPercentage = (clickedPos / clickedpPlaylistWidth) * 100
            let playlistItemDuration = moment(playlistItem.stopUTC * 1000).diff(playlistItem.startUTC * 1000)
            let player = videojs.getPlayer(this.playerIds[0])

            if (!sameItem) {
                player.src({
                    type: 'application/x-mpegURL',
                    src: this.mediaUrl(0, clickedPlaylistItemIndex)
                })
                if (this.subs) this.addSubs(this.subs)
            }

            let seekLocationToSeconds = Math.round((playlistItemDuration * (clickedPosPercentage / 100)) / 1000)
            let startTimeUTC = playlistItem.startUTC
            if (typeof startTimeUTC === 'string') startTimeUTC = parseInt(startTimeUTC, 10);

            let seekLocation = startTimeUTC + seekLocationToSeconds

            if (!sameItem) {
                this.player.ready(() => {
                    this.seek(seekLocation)
                    player.play()
                })

            } else {
                this.seek(seekLocation)

            }
        }

        setCustomSource(source) {
            for (var i = 0; i < this.playerIds.length; i++) {
                videojs.getPlayer(this.playerIds[i]).src(source);
            }
        }

        addLanguageControl() {
            let $fullScreenControl = $('#player1').find('.vjs-fullscreen-control');
            let tempLangPicker = ''


            if (this.audioLangs.length === 1) {
                //do nothing for SEG builds, EC need visuals
            } else {
                tempLangPicker = '<div class="vjs-menu-button vjs-menu-button-popup vjs-control vjs-button dropup">' +
                    '<button class="dropbtn dropbtn-lang">' + this.languages.getLanguage(this.audioLang) + '</button>' +
                    '<div class="dropup-content">'


                if (typeof this.audioLangs === 'object' &&
                    !Array.isArray(this.audioLangs) &&
                    this.audioLangs !== null) {
                    this.audioLangs = Object.values(this.audioLangs)
                }

                for (let lang of this.audioLangs) {
                    tempLangPicker += '<span class="vjs-lang" data-lang="' + lang + '">' + this.languages.getLanguage(lang) + '</span>'
                }

                tempLangPicker += '</div></div>';
            }

            let $languagePicker = $(tempLangPicker)

            $languagePicker.insertBefore($fullScreenControl);

            $('.vjs-lang').on('click', this.changeLanguageClickHandler.bind(this))
        }

        addQualityControl() {
            let $fullScreenControl = $('#player1').find('.vjs-fullscreen-control')

            let tempQualityPicker = ''

            if (this.qualityLevels.length === 1) {
                //Do nothing for seg builds, EC needs visuals
            } else {
                tempQualityPicker = '<div class="vjs-menu-button vjs-menu-button-popup vjs-control vjs-button dropup">' +
                    '<button class="dropbtn dropbtn-qual">' + this.quality + '</button>' +
                    '<div class="dropup-content">';

                for (let quality of this.qualityLevels) {
                    tempQualityPicker += '<span class="vjs-qual">' + quality + '</span>'
                }

                tempQualityPicker += '</div></div>';
            }

            let $qualityPicker = $(tempQualityPicker)

            $qualityPicker.insertBefore($fullScreenControl);

            $('.vjs-qual').on('click', this.changeQualityClickHandler.bind(this))
        }

        changeLanguageClickHandler(e) {
            this.changeLanguage($(e.currentTarget).data('lang'))
        }

        changeLanguage(lang) {
            this.audioLang = lang
            this.reloadPlayer()
            $('.dropbtn-lang').html(this.languages.getLanguage(lang));
        }

        changeQualityClickHandler(e) {
            this.changeQuality($(e.currentTarget).html())
        }

        changeQuality(qual) {
            this.quality = qual
            this.reloadPlayer()
            $('.dropbtn-qual').html(this.quality);
        }

        getCurrentLanguage() {
            return this.audioLang
        }

        getCurrentQuality() {
            return this.quality
        }

        addSeekStepControl() {
            let $fullScreenControl = $('#player1').find('.realTime')

            let $seekStepControl = '<button class="stepBack vjs-button"><span class="number">15</span><span class="vjs-icon-replay"></span></button>'
            $seekStepControl += '<button class="stepForward vjs-button"><span class="number">15</span><span class="vjs-icon-replay"></span></button>'


            $($seekStepControl).insertBefore($fullScreenControl);

            $('.stepBack').on('click', (e) => {

                e.preventDefault()

                let currentPos = this.getCurrentPosition().dateObject
                var t = new Date();
                currentPos.setSeconds(currentPos.getSeconds() - 15);
                this.seek(currentPos.getTime() / 1000)

                return false
            })


            $('.stepForward').on('click', (e) => {

                e.preventDefault()

                let currentPos = this.getCurrentPosition().dateObject
                var t = new Date();
                currentPos.setSeconds(currentPos.getSeconds() + 15);
                this.seek(currentPos.getTime() / 1000)

                return false
            })
        }

        reloadPlayer() {
            if (this.status !== 'live') {
                let tempPosition = this.getCurrentPosition()


                this.player.src({
                    type: 'application/x-mpegURL',
                    src: this.mediaUrl(0, 0)
                });



                this.player.ready(() => {
                    if (this.subs) this.addSubs(this.subs)
                    this.player.currentTime(tempPosition.timePassed)
                    this.player.play()
                })
            } else {
                const currentTracks = Array.from(this.player.remoteTextTracks());

                for (let i = 0; i < currentTracks.length; i++) {
                    const track = currentTracks[i];
                    this.player.removeRemoteTextTrack(track)
                }

                this.player.src({
                    type: 'application/x-mpegURL',
                    src: this.mediaUrl(0, 0)
                });

                for (let i = 0; i < currentTracks.length; i++) {
                    const track = currentTracks[i];
                    const newTrack = this.player.addRemoteTextTrack({
                        "kind": track.kind,
                        "label": track.label,
                        "srclang": track.language
                    });
                }

                this.player.ready(() => {
                    $('.vjs-subs-caps-button .vjs-menu ul li').on('click', (event) => {
                        let chosenLanguage = $(event.currentTarget).find('.vjs-menu-item-text').html()
                        let lang = chosenLanguage.split('-')
                        if (lang.length > 0 && lang[0] !== 'captions off') {
                            $('#live-trans').show()
                            $('#' + this.ids[0]).trigger('playerSubLanguageChanged', [lang[0]]);
                        } else if (lang.length > 0 && lang[0] === 'captions off') {
                            $('#live-trans').hide()
                        }
                    })
                    this.player.play()
                })
            }



            /*         for (var i = 0; i < this.playerIds.length; i++) {
                        videojs.getPlayer(this.playerIds[i]).pause()
    
                        videojs.getPlayer(this.playerIds[i]).src({
                            type: 'application/x-mpegURL',
                            src: this.mediaUrl(i, 0)
                        });
                    } */
        }

        addCustomRealTimeDisplay() {
            var Button = videojs.getComponent('Button');

            var MyButton = videojs.extend(Button, {
                constructor: function () {
                    Button.apply(this, arguments);
                    this.addClass('realTime')
                    this.addClass('dissabled')
                    /* initialize your button */
                }
            });

            videojs.registerComponent('MyButton', MyButton);

            var player = videojs(this.playerIds[0]);
            player.getChild('controlBar').addChild('myButton', {}, 2);

            let item = this.playlist.playlists[0]
            let firstItem = item.playlist[0]
            let lastItem = item.playlist[item.playlist.length - 1]
            let totalDuration = moment(lastItem.stopUTC * 1000).diff(firstItem.startUTC * 1000);

            var startTime = moment(firstItem.startTime)

            //$('.realTime').text(startTime.format('HH:mm:ss') + "   /   " + moment(lastItem.stopTime).format('HH:mm:ss'))
            $('.realTime').text('On Demand: ' + startTime.format('HH:mm:ss'))
            var newTime = Object.assign({}, startTime)

            player.on('timeupdate', (e) => {

                newTime = moment(startTime).add(this.timeline.secondsPlayed, 'seconds')

                //$('.realTime').text(newTime.format('HH:mm:ss') + "   /   " + moment(lastItem.stopTime).format('HH:mm:ss'))
                $('.realTime').text('On Demand: ' + newTime.format('HH:mm:ss'))
            })
        }

        setPoster(img) {
            videojs.getPlayer(this.ids[0]).poster(img)
        }

        destroy() {
            let allPlayers = videojs.getAllPlayers();

            if (Object.keys(allPlayers).length !== 0) {
                allPlayers.forEach(player => {
                    player.dispose();
                });
            }

            $('#playerwrap').empty();
        }

        isActive() {
            return !videojs.getPlayer(this.ids[0]).paused();
        }

        addCustomClickEvents() {
            var player1 = videojs.getPlayer(this.ids[0])
            var player2 = videojs.getPlayer(this.ids[1])
            player2.muted(true);

            player1.on('play', function () {
                player2.play()
            });

            player1.on('pause', function () {
                player2.pause()
            })

            player1.on("seeking", function (e) {
                player2.currentTime(player1.currentTime());
            });
        }

        seek(utc) {
            let playlistItem = this.getPlaylistItemFromPosition(utc)
            let player = videojs.getPlayer(this.playerIds[0])

            let date = new Date(utc);

            if (!(Math.abs(Date.now() - date) < Math.abs(Date.now() - date * 1000))) {
                utc *= 1000
            }

            if (playlistItem && (playlistItem.currentItem !== this.timeline.currentItem)) {

                this.timeline = playlistItem

                player.src({
                    type: 'application/x-mpegURL',
                    src: this.mediaUrl(0, this.timeline.currentItem)
                })

            }


            let startTime = this.timeline.playlist[0].startUTC


            if (this.status === 'live' && this.dvr) {
                startTime = this.startUTC
            }

            if (typeof startTime === 'string') startTime = parseInt(startTime, 10);

            date = new Date(startTime);

            if (!(Math.abs(Date.now() - date) < Math.abs(Date.now() - date * 1000))) {
                startTime *= 1000
            }

            let timeDiff = moment.duration(moment(utc).diff(moment(startTime))).valueOf()

            if (this.status !== 'live') {
                let startutc = this.playlist.playlists[0].playlist[0].startUTC * 1000
                if (typeof startutc === 'string') startutc = parseInt(startutc, 10);

                let endutc = this.playlist.playlists[0].playlist[this.playlist.playlists[0].playlist.length - 1].stopUTC * 1000
                if (typeof endutc === 'string') endutc = parseInt(endutc, 10);

                let totalDuration = moment(endutc).diff(moment(startutc), 'seconds')

                let seekDuration = moment(utc).diff(moment(startutc), 'seconds')

                let seekPercentage = seekDuration / totalDuration * 100

                $('#progress').width(seekPercentage + '%')
            }

            player.ready(function () {
                if (this.subs) this.addSubs(this.subs)

                player.currentTime(timeDiff / 1000)
                this.play()
            });

        }

        getPlaylistItemFromPosition(utc) {
            let item = null

            for (let i = 0; i < this.playlist.playlists[0].playlist.length; i++) {
                let playlistItem = this.playlist.playlists[0].playlist[i]

                if (utc > playlistItem.startUTC && utc < playlistItem.stopUTC) {
                    item = {
                        currentItem: i,
                        playlist: [playlistItem],
                        finished: false
                    }
                }
            }

            return item
        }

        createInstance(ids) {
            let HTMLcontainer = '<div id="smvplayer">';

            ids.forEach(function (id) {
                if (ids.length > 1 && id === ids[1]) {
                    HTMLcontainer += '<video id="' + id + '" class="video-js vjs-theme-sea vjs-big-play-centered vjs-16-9 vjs-second-player" preload="none"></video>';
                } else {
                    HTMLcontainer += '<video id="' + id + '" controls class="video-js vjs-theme-sea vjs-big-play-centered vjs-16-9" preload="none"></video>';
                }
            });

            HTMLcontainer += '</div>';

            $('#playerwrap').append(HTMLcontainer)
        }

        getCurrentPosition() {
            moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

            let player = videojs.getPlayer(this.ids[0]);

            if (player && this.playlist) {
                let startutc = this.playlist.playlists[0].playlist[0].startUTC * 1000
                let endutc = this.playlist.playlists[0].playlist[this.playlist.playlists[0].playlist.length - 1].stopUTC * 1000

                let progressPercentage = $('#progress').width() / ($('#seekbar').width() + 1)

                if (progressPercentage > 1) {
                    this.fullyPlayed = true
                    progressPercentage = 1
                }

                let timePassed = this.timeline.secondsPlayed

                let playlistTime = this.playlist.playlists[0].playlist[0].startUTC * 1000

                let calculatedTime = moment(playlistTime).add(timePassed, 'seconds')

                return {
                    'timePassed': timePassed,
                    'utc': calculatedTime.valueOf(),
                    'realTime': moment(calculatedTime).format('HH:mm:ss'),
                    'dateObject': moment(calculatedTime).toDate()
                }
            } else {
                return null;
            }
        }

        setStatusMessages(message, customClass = '') {
            $('#smvplayer').addClass('modal-open');

            const contentEl = document.createElement('div');
            contentEl.innerHTML = message;

            const vjsPlayer = videojs(this.ids[0]);

            // log
            this._debugLog('[modal] setStatusMessages', { customClass, message });

            if (this._statusModal && !this._statusModal.isDisposed_) {
                this._debugLog('[modal] reuse existing modal -> open/update');
                this._statusModal.contentEl().innerHTML = contentEl.innerHTML;
                this._statusModal.open();

                this._statusModal.removeClass(this._statusModalClass || '');
                this._statusModal.addClass('modal-style');
                if (customClass) this._statusModal.addClass(customClass);
                this._statusModalClass = customClass;
                return;
            }

            const modal = vjsPlayer.createModal(contentEl);
            modal.addClass('modal-style');
            if (customClass) modal.addClass(customClass);

            this._statusModal = modal;
            this._statusModalClass = customClass;

            this._debugLog('[modal] created new modal');
        }

        clearStatusMessages() {
            $('#smvplayer').removeClass('modal-open');

            if (this._statusModal && !this._statusModal.isDisposed_) {
                this._debugLog('[modal] clear -> close + dispose');
                this._statusModal.close();
                this._statusModal.dispose();
            } else {
                this._debugLog('[modal] clear -> no modal to dispose');
            }

            this._statusModal = null;
            this._statusModalClass = null;
        }


        getStatus() {
            return this.status
        }

        play() {
            Object.values(videojs.getPlayers()).forEach(
                player => {
                    this.playPromises.push(player.play());
                    this.retries = 0;
                }
            );
        }

        stop() {
            Object.values(videojs.getPlayers()).forEach(
                player => {
                    Promise.all(this.playPromises).then(() => {
                        player.pause()
                        this.playPromises = []
                    })
                }
            );
        }

        getCurrentPlaylistItem() {
            return this.playlist;
        }

        // Builds a mediaURL from the supplied MediaSetup / Playlist
        mediaUrl(channelIndex, playlistIndex) {
            var sMediaUrl = "";

            //id = this.ids[0];

            var source;


            if (this.getCurrentPlaylistItem()) {
                source = this.getCurrentPlaylistItem();
            } else {
                sMediaUrl = "na";
                return sMediaUrl;
            }

            var qualities = Object.keys(source.playlists[channelIndex].playlist[playlistIndex].source.qualities);

            this.qualityLevels = qualities


            if (this.smil && (this.quality == "")) {
                this.qualityLevels.unshift("Auto")
                this.quality = "Auto"
            }


            this.audioLangs = source.playlists[channelIndex].playlist[playlistIndex].source.languages

            //var source = timeline.playlist[timeline.currentItem].source;

            if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === "none") {
                sMediaUrl = "na";
                return sMediaUrl;
            }

            var protocol = "";

            if (source.forceProtocol) {
                if (source.forceProtocol !== false && !source.multicast) {
                    console.log("[mediaUrl] ForceProtocol set to: " + source.forceProtocol);
                    protocol = source.forceProtocol;
                } else if (source.multicast !== false && !this.unicastFallback) {
                    protocol = 'rtsp';
                } else if (source.forceProtocol !== false) {
                    console.log("[mediaUrl] ForceProtocol set to: " + source.forceProtocol);
                    protocol = source.forceProtocol;
                }
            } else {
                if (window.location.protocol == "https:") {
                    protocol = "https";
                } else {
                    protocol = "http";
                }
            }
            sMediaUrl = protocol + '://';

            var serverPath = "";
            if (this.unicastFallback || !source.multicast) {
                if (!this.ports[protocol] && protocol == "https") {
                    serverPath += source.server + ":" + '443' + '/' + source.application + "/";
                } else {
                    serverPath += source.server + ":" + this.ports[protocol] + '/' + source.application + "/";
                }
            } else {
                // MULTICAST SERVER
                if (!this.ports[protocol] && protocol == "https") {
                    serverPath += source.multicast.server + ":" + '443' + '/' + source.application + "/";
                } else {
                    serverPath += source.multicast.server + ":" + this.ports[protocol] + '/' + source.application + "/";
                }
            }

            sMediaUrl += serverPath;

            var mediaFile = "";
            var mode = "";

            if (this.quality === 'Auto') {
                mode = "SMIL";
            } else {
                mode = "FALLBACK";
            }

            // Required since apaprntly the UI adds an enter character into the quality for no reasoning.
            if (this.quality) {
                this.quality = this.quality.trim();
            }

            if (!this.quality || this.quality === '') {
                if (source.playlists[channelIndex].playlist[playlistIndex].source.qualities.hasOwnProperty("high")) {
                    this.quality = 'high';
                } else {
                    for (var qualName in source.playlists[channelIndex].playlist[playlistIndex].source.qualities) {
                        this.quality = qualName;
                        break; // neem de laatste -> hoogste qualiteit want komt van low naar high binnen uit cms
                    }
                }
            }

            //console.log('SELECTED QUALITY: '+quality);
            switch (mode) {
                case "SMIL":
                    // Live
                    if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'live') {

                        mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.smil[this.audioLang];
                    }
                    // Vod
                    else if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'vod') {

                        mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.smil;
                    }

                    if (!mediaFile) {

                        for (var qualName in source.playlists[channelIndex].playlist[playlistIndex].source.qualities) {
                            this.quality = qualName;
                            //break; // neem de laatste -> hoogste qualiteit want komt van low naar high binnen uit cms
                        }

                        mode = 'FALLBACK';

                        // Live
                        if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'live') {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.qualities[this.quality][this.audioLang];
                        }
                        // Vod
                        else if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'vod') {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.qualities[this.quality];

                        } else { }
                    }


                    break;
                case "FALLBACK":
                    // Double check if quality is not auto and smil stuffies
                    if (this.quality == "Auto") {


                        if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'live') {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.smil[this.audioLang];
                        } else {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.smil;
                        }

                    } else {
                        // Live
                        if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'live') {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.qualities[this.quality][this.audioLang];
                        }
                        // Vod
                        else if (source.playlists[channelIndex].playlist[playlistIndex].source.streamType === 'vod') {

                            mediaFile = source.playlists[channelIndex].playlist[playlistIndex].source.qualities[this.quality];

                        } else { }

                    }
                    break;
            }

            //console.log('mediaUrl() mode : '+mode);
            //console.log('mediaUrl() mediaFile : '+mediaFile);

            //console.log('mediaUrl() mode : '+mode);
            //console.log('mediaUrl() mediaFile : '+mediaFile);

            if (mode === "SMIL") {

                // If the application has "_definst_" don't add it before the smil. Otherwise do add it behind it.
                if (source.application.indexOf('_definst_') > -1) {
                    sMediaUrl += 'smil:';
                } else {
                    sMediaUrl += '_definst_/smil:';
                }
            }

            sMediaUrl += mediaFile;

            // ---------- NIEUW: playlist + querystring MET secureToken (live + vod) ----------
            let appendix = "";

            // 1) Altijd /playlist.m3u8 voor HLS (http/https)
            if (protocol === 'http' || protocol === 'https') {
                appendix = "/playlist.m3u8";
            }

            const streamSource = source.playlists[channelIndex].playlist[playlistIndex].source;
            const isLive = streamSource.streamType === "live";

            // 2) Query parameters verzamelen
            const params = [];

            // 2a) secureToken kiezen:
            //  - multi-lang: secureToken[this.audioLang]
            //  - fallback:   secureToken._default
            //  - legacy:     secureToken.{prefix,hash,...}
            let token = null;
            const st = streamSource.secureToken || {};

            // current language / quality in de player
            const currentLang = this.audioLang;
            // 'Auto' betekent: we spelen de SMIL → quality-key = 'smil'
            const currentQualityKey = (this.quality === "Auto" ? "smil" : this.quality);

            let tokenSet = null;

            if (currentLang && st[currentLang]) {
                const langNode = st[currentLang];

                tokenSet =
                    // 1) token specifiek voor deze quality (high / medium / low)
                    (currentQualityKey && langNode[currentQualityKey]) ||
                    // 2) anders: token voor de SMIL van deze taal
                    langNode.smil ||
                    // 3) of: token direct op lang-node (legacy per taal)
                    ((langNode.prefix && langNode.hash) ? langNode : null);
            }

            // 4) geen match op taal → fallback op _default
            if (!tokenSet && st._default) {
                tokenSet = st._default;
            }

            // 5) laatste fallback: flat token-structuur
            if (!tokenSet && st.prefix && st.hash) {
                tokenSet = st;
            }

            // 2a.1) secureToken parameters (indien aanwezig)
            if (tokenSet && tokenSet.hash) {
                const prefix = tokenSet.prefix || "xst";

                params.push(prefix + "hash=" + encodeURIComponent(tokenSet.hash));

                if (tokenSet.starttime) {
                    params.push(prefix + "starttime=" + encodeURIComponent(tokenSet.starttime));
                }
                if (tokenSet.endtime) {
                    params.push(prefix + "endtime=" + encodeURIComponent(tokenSet.endtime));
                }
            }

            // 2b) Live / VOD specifieke dingen
            if (isLive) {
                // LIVE: multicastplay flag zoals vroeger
                if (streamSource.multicast) {
                    params.push("multicastplay");
                }
            } else {
                // VOD: audio track param
                params.push("tracks=" + this.audioLang);
            }

            // 2c) Wowza start/stop (live én vod) – let op: dit komt van top-level source
            if (source.start) {
                params.push("wowzaplaystart=" + parseInt(source.start));
            }
            if (source.stop) {
                params.push("wowzaplayduration=" + parseInt(source.stop));
            }

            // 3) Querystring achter /playlist.m3u8 plakken
            if (params.length > 0) {
                appendix += "?" + params.join("&");
            }

            // 4) Appendix achter de basis-URL plakken
            // 4) Appendix achter de basis-URL plakken
            sMediaUrl += appendix;

            // Init URL (incl. parameters) eenmalig bewaren
            if (this.sInitMediaUrl === false) {
                console.log('[mediaUrl] Debug | Setting the sInitMediaUrl to: ' + sMediaUrl);
                this.sInitMediaUrl = sMediaUrl;
            }

            // 5) DVR parameter voor live (netjes met ? of &)
            if (isLive && this.dvr === true) {
                const joinChar = (sMediaUrl.indexOf("?") === -1) ? "?" : "&";
                sMediaUrl += joinChar + "dvr";
                $('.vjs-progress-control').addClass('dvr-progress');
            }

            // 6) UUID-parameter als laatste toevoegen
            if (!this.uuid) {
                this.uuid = uuidv4();
            }


            const uuidSeparator = sMediaUrl.indexOf('?') === -1 ? '?' : '&';
            sMediaUrl += uuidSeparator + 'uuid=' + encodeURIComponent(this.uuid);

            if (this._debugThrottle('mediaUrl', 2000)) {
                this._debugLog('[mediaUrl] built', {
                    channelIndex,
                    playlistIndex,
                    quality: this.quality,
                    audioLang: this.audioLang,
                    isLive: streamSource.streamType === 'live',
                    url: sMediaUrl
                });
            }


            return sMediaUrl;

        };

        // Create a GUID for statistics on wowza \o/
        S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };

        addSubs(subs) {
            this.player.ready(() => {
                this.subs = subs
                this.player.textTrackSettings = false

                if (this.status === 'live') {

                    subs.forEach(sub => {
                        // Process the VTT data here

                        let blob = new Blob([sub.data], {
                            type: "text/vtt"
                        });

                        let blobURL = URL.createObjectURL(blob)


                        this.player.addRemoteTextTrack({
                            src: blobURL,
                            srclang: sub.language,
                            label: sub.language
                        }, false);

                    })

                    $('.vjs-subs-caps-button .vjs-menu ul li').on('click', (event) => {
                        let chosenLanguage = $(event.currentTarget).find('.vjs-menu-item-text').html()
                        this.selectedSub = chosenLanguage

                        let lang = chosenLanguage.split('-')


                        if (lang.length > 0 && lang[0] !== 'captions off') {
                            $('#live-trans').show()
                            $('#' + this.ids[0]).trigger('playerSubLanguageChanged', [lang[0]]);
                        } else if (lang.length > 0 && lang[0] === 'captions off') {
                            $('#live-trans').hide()
                        }
                    })
                } else {

                    // Loop through the array
                    for (let language in subs) {
                        this.player.addRemoteTextTrack({
                            src: subs[language][this.timeline.currentItem].vtt,
                            srclang: language,
                            label: language
                        }, false);
                    }

                    $('.vjs-subs-caps-button .vjs-menu ul li').on('click', (event) => {
                        let chosenLanguage = $(event.currentTarget).find('.vjs-menu-item-text').html()

                        this.selectedSub = chosenLanguage

                        let lang = subs[chosenLanguage][this.timeline.currentItem]


                        if (Object.keys(lang).length > 0 && chosenLanguage !== 'captions off') {
                            $('#live-trans').show()
                            $('#' + this.ids[0]).trigger('playerSubLanguageChanged', [lang]);
                        } else if (lang.length > 0 && lang[0] === 'captions off') {
                            this.selectedSub = null
                            $('#live-trans').hide()
                        }
                    })

                }


            })
        }

        //$('.vjs-subtitles-menu-item').find('span:contains(' + sub.label + ')').trigger('click')


        addSubtitles(subs) {
            subs.forEach((sub) => {
                if (sub.url.includes('.srt')) {
                    let xmlhttp;

                    if (window.XMLHttpRequest) { // code for IE7+, Firefox, Chrome, Opera, Safari
                        xmlhttp = new XMLHttpRequest();
                    } else { // code for IE6, IE5
                        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                    }
                    xmlhttp.onreadystatechange = () => {
                        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {

                            let srt2vtt = this.srt2webvtt(xmlhttp.responseText)

                            let blob = new Blob([srt2vtt], {
                                type: "text/vtt"
                            });

                            let blobURL = URL.createObjectURL(blob)

                            this.player.addRemoteTextTrack({
                                src: blobURL,
                                srclang: sub.lang,
                                label: sub.language
                            })
                        }
                    }
                    xmlhttp.open("GET", sub.url, false);
                    xmlhttp.send();
                } else {
                    this.player.addRemoteTextTrack({
                        src: sub.url,
                        srclang: sub.lang,
                        label: sub.language
                    })
                }

                $('.vjs-subtitles-menu-item').trigger('click')

            })
        }

        srt2webvtt(data) {
            // remove dos newlines
            var srt = data.replace(/\r+/g, '');
            // trim white space start and end
            srt = srt.replace(/^\s+|\s+$/g, '');

            // get cues
            var cuelist = srt.split('\n\n');
            var result = "";

            if (cuelist.length > 0) {
                result += "WEBVTT\n\n";
                for (var i = 0; i < cuelist.length; i = i + 1) {
                    result += this.convertSrtCue(cuelist[i]);
                }
            }

            return result;
        }

        convertSrtCue(caption) {
            // remove all html tags for security reasons
            //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');

            var cue = "";
            var s = caption.split(/\n/);

            // concatenate muilt-line string separated in array into one
            while (s.length > 3) {
                for (var i = 3; i < s.length; i++) {
                    s[2] += "\n" + s[i]
                }
                s.splice(3, s.length - 3);
            }

            var line = 0;

            // detect identifier
            if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
                cue += s[0].match(/\w+/) + "\n";
                line += 1;
            }

            // get time strings
            if (s[line].match(/\d+:\d+:\d+/)) {
                // convert time string
                var m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);
                if (m) {
                    cue += m[1] + ":" + m[2] + ":" + m[3] + "." + m[4] + " --> " +
                        m[5] + ":" + m[6] + ":" + m[7] + "." + m[8] + "\n";
                    line += 1;
                } else {
                    // Unrecognized timestring
                    return "";
                }
            } else {
                // file format error or comment lines
                return "";
            }

            // get cue text
            if (s[line]) {
                cue += s[line] + "\n\n";
            }

            return cue;
        }

        addVttSubs(data) {

            this.player.addRemoteTextTrack({
                src: data,
                srclang: 'it-IT',
                label: 'english',
                kind: 'subtitles'
            }, true);
        }

        addLiveCaption(caption) {

            let $liveTrans = $('#live-trans')


            if (!$liveTrans.length) {
                $('.video-js').prepend('<div id="live-trans"><p></p></div>')
            }

            let player = videojs.getPlayer(this.playerIds[0])


            /*         if (player.liveTracker.behindLiveEdge()) {
                        $liveTrans.hide()
                    } else {
                        $liveTrans.show()
                    } */
            $liveTrans = $('#live-trans')

            $liveTrans.removeClass('hide')

            if (!this.isPlaying) {
                $liveTrans.addClass('hide')
            }
            if (this.liveTranscriptions.length === 2) {
                this.liveTranscriptions.shift();
            }

            if (this.liveTranscriptions.length == 0 || (this.liveTranscriptions.length > 0 && this.liveTranscriptions[0] !== caption)) {
                this.liveTranscriptions.push(caption)
            }

            $liveTrans.find('p').text('')

            /*         this.liveTranscriptions.forEach((value, index) => {
    
                        let transClass = ''
                        if (index === 0 && this.liveTranscriptions.length === 1) {
                            textToShow += '\n <span class="new">' + value + '</span>'
                        } else if (index === 1) {
                            textToShow += '\n <span class="new">' + value + '</span>'
                        } else {
                            textToShow += '\n <span>' + value + '</span>'
                        }
    
                    }) */

            let textToShow = '<span class="new">' + caption + '</span>'

            $liveTrans.find('p').html(textToShow)

        }

        install403Handler() {
            // je hoeft player niet; dit is globaal op VHS
            try {
                const Vhs = (videojs && videojs.Vhs) ? videojs.Vhs : null;
                if (!Vhs || !Vhs.xhr) return;

                // Al gepatched? stop.
                if (Vhs.__smv403Patched) return;

                const routerXhr = Vhs.xhr;

                // In veel VHS builds is routerXhr.original de "echte" low-level xhr-functie.
                // In jouw build wordt .original ook als flag gebruikt, dus we checken expliciet op function.
                const innerXhr = (typeof routerXhr.original === "function")
                    ? routerXhr.original
                    : null;

                // Als er geen inner function is, dan kunnen we niet veilig patchen in jouw build
                // (want router kan via Hr.Vhs.xhr recursief worden).
                if (!innerXhr) {
                    console.warn("[403Handler] No inner xhr function found (routerXhr.original is not a function). Not patching to avoid recursion.");
                    return;
                }

                const self = this;

                function getUrl(options) {
                    return options?.uri || options?.url || (typeof options === "string" ? options : "");
                }

                let reloading = false;
                let lastReloadAt = 0;

                function wrappedInner(options, callback) {
                    const url = getUrl(options);

                    return innerXhr.call(this, options, function (error, response) {
                        // status kan op verschillende plaatsen zitten
                        const status =
                            response?.statusCode ??
                            response?.status ??
                            error?.statusCode ??
                            error?.status;

                        if (status === 403) {
                            console.warn("[403Handler] 403 url:", url, { status, response, error });

                            const now = Date.now();
                            if (!reloading && (now - lastReloadAt) > 4000) {
                                reloading = true;
                                lastReloadAt = now;

                                // uit de xhr callstack stappen
                                setTimeout(async () => {
                                    try {
                                        await self.reloadWithFreshTokens();
                                    } finally {
                                        reloading = false;
                                    }
                                }, 0);
                            }
                        }

                        callback(error, response);
                    });
                }

                // markeer
                wrappedInner.__smvIsWrapper = true;
                wrappedInner.__smvOriginalInner = innerXhr;

                // ✅ patch INNER, niet router
                routerXhr.original = wrappedInner;

                Vhs.__smv403Patched = true;
                console.log("[403Handler] patched routerXhr.original (inner xhr) safely");
            } catch (e) {
                console.log("install403Handler failed:", e);
            }
        }


        setTokenRefreshHandler(fn) {
            this.tokenRefreshHandler = fn;
        }

        updatePlaylist(newPlaylist) {
            if (!newPlaylist) return;
            this.playlist = newPlaylist;
            this.ports = newPlaylist.ports;
            this.server = newPlaylist.server;
            this.clientIp = newPlaylist.clientIp;

            if (this.playlist.playlists) {
                this.smil = this.playlist.playlists[0].playlist[0].source.smil;
            }

            console.log("NEW PLAYLIST IS SET: ", newPlaylist)
        }

        scheduleTokenRefreshFromPlaylist() {
            const streamSource = this.playlist?.playlists?.[0]?.playlist?.[0]?.source;
            if (!streamSource?.secureToken) return;

            const st = streamSource.secureToken;

            const currentLang = this.audioLang;
            const currentQualityKey = (this.quality === "Auto" ? "smil" : this.quality);

            const langNode = currentLang ? st[currentLang] : null;

            const tokenSet =
                (langNode && (langNode[currentQualityKey] || langNode.smil || (langNode.prefix && langNode.hash ? langNode : null))) ||
                st._default ||
                (st.prefix && st.hash ? st : null);


            console.log("token set: ", tokenSet)

            const end =
                parseInt(tokenSet?.test_endtime, 10) ||
                parseInt(tokenSet?.endtime, 10);
            if (!end) return;

            // 15s voor verval refreshen
            const refreshAtMs = (end * 1000) - 15000;
            const delay = refreshAtMs - Date.now();

            console.log("[tokenRefresh] will refresh in", Math.round(delay / 1000), "s",
                { end, now: Math.floor(Date.now() / 1000), quality: this.quality, lang: this.audioLang }
            );


            // ✅ LOG: hoeveel tijd nog + wanneer exact
            const now = Date.now();
            const secsLeft = Math.max(0, Math.round(delay / 1000));
            const refreshAtIso = new Date(refreshAtMs).toISOString();
            const expiresAtIso = new Date(end * 1000).toISOString();



            // simpele anti-spam: log max 1x per 10s
            if (!this.__lastRefreshScheduleLogAt || (now - this.__lastRefreshScheduleLogAt) > 10000) {
                this.__lastRefreshScheduleLogAt = now;

                console.log(
                    "[TokenRefresh] scheduled",
                    {
                        lang: currentLang,
                        qualityKey: currentQualityKey,
                        expiresAtIso,
                        refreshAtIso,
                        secsLeft,
                        endtime: end,
                        refreshLeadSeconds: 15
                    }
                );
            }

            if (this.__tokenRefreshTimer) clearTimeout(this.__tokenRefreshTimer);

            if (delay <= 0) {
                console.warn("[TokenRefresh] delay<=0, refreshing immediately");
                this.reloadWithFreshTokens();
                return;
            }

            this.__tokenRefreshTimer = setTimeout(() => {
                console.log("[TokenRefresh] timer fired -> reloadWithFreshTokens()");
                this.reloadWithFreshTokens();
            }, delay);
        }



        reloadWithFreshTokens() {
            const now = Date.now();
            if (now - this.lastTokenRefreshAt < 5000) return; // throttle
            this.lastTokenRefreshAt = now;

            if (this.refreshingTokens) return;
            this.refreshingTokens = true;

            const isVod = this.status !== "live";
            const pos = isVod ? this.getCurrentPosition() : null;
            const currentItem = this.timeline?.currentItem ?? 0;

            try { this.stop(); } catch (e) { }

            Promise.resolve()
                .then(async () => {
                    if (!this.tokenRefreshHandler) return null;

                    // handler moet newPlaylist returnen
                    const newPlaylist = await this.tokenRefreshHandler();
                    return newPlaylist || null;
                })
                .then((newPlaylist) => {
                    if (!newPlaylist) throw new Error("Token refresh failed");

                    this.updatePlaylist(newPlaylist);

                    this.uuid = uuidv4();

                    const idx = isVod ? currentItem : 0;

                    this.player.src({
                        type: "application/x-mpegURL",
                        src: this.mediaUrl(0, idx),
                    });

                    this.scheduleTokenRefreshFromPlaylist();

                    this.player.ready(() => {
                        if (this.subs) this.addSubs(this.subs);

                        if (isVod && pos) {
                            this.player.currentTime(pos.timePassed);
                        } else if (this.status === "live") {
                            $(".vjs-seek-to-live-control").trigger("click");
                        }

                        this.play();
                    });
                })
                .catch(() => {
                    this.setStatusMessages("Stream unavailable (token refresh failed).", "no-close");
                })
                .finally(() => {
                    this.refreshingTokens = false;
                });
        }



    }
    module.exports = smvplayer;
})();
